import { ICoreContext, IRequestContext } from "@msdyn365-commerce/core";
import { AttributeValue, Customer, CustomerAttribute } from "@msdyn365-commerce/retail-proxy";
import { IProductAgreement } from "./types";

function getAgreementAttributeRecordIds(context: ICoreContext | IRequestContext): number[] | undefined {
    const request = 'request' in context ? context.request : context;

    return request.app.config?.agreementProductAttributeRecordId
        ?.split(',')
        .map(Number)
        .filter(Boolean) as number[] | undefined;
}

export function getAgreementProductRefinersToHide(context: ICoreContext, customer: Customer | undefined): number[] | undefined {
    const refinerIds = getAgreementAttributeRecordIds(context);

    // Hide all refiners if customer is not available
    if (!customer) {
        return refinerIds;
    }

    const refinersToHide = refinerIds?.filter(refinerId => {
        const attribute = customer.Attributes?.find(x => x.RecordId === refinerId);
        return !attribute?.AttributeValue?.BooleanValue;
    });

    return refinersToHide;
}

export function getProductAgreements(context: ICoreContext | IRequestContext, attributes: AttributeValue[] | undefined): IProductAgreement[] | undefined {
    const checkAgreements = getAgreementAttributeRecordIds(context);

    if (!attributes || !checkAgreements) {
        return undefined;
    }

    const agreements: IProductAgreement[] = checkAgreements
        .map(id => attributes.find(attr => attr.RecordId === id))
        .filter(x => x && x.BooleanValue)
        .map(x => ({
            AttributeRecordId: x?.RecordId,
            Name: x?.Name
        }) as IProductAgreement);

    return agreements;
}

export function getCustomerAgreements(context: ICoreContext | IRequestContext, attributes: CustomerAttribute[] | undefined): IProductAgreement[] | undefined {
    const checkAgreements = getAgreementAttributeRecordIds(context);

    if (!attributes || !checkAgreements) {
        return undefined;
    }

    const findAttributes = checkAgreements
        .map(id => attributes.find(attr => attr.RecordId === id))
        .filter(Boolean) as CustomerAttribute[];
    const agreements: IProductAgreement[] = findAttributes.filter(x => x.AttributeValue?.BooleanValue).map(x => ({
        AttributeRecordId: x?.RecordId,
        Name: x?.Name
    }) as IProductAgreement);

    return agreements;
}